export default ()=>{
  var width=document.documentElement.clientWidth;
  var baseUnit=16;
  document.documentElement.style.fontSize=baseUnit+'px';
}



// WEBPACK FOOTER //
// ./src/common/rem.js